import classNames from 'classnames';
import React from 'react';

import { Tabs } from '@eika/tabs';

import useTranslation from '../../hooks/useTranslation';
import { BsuDisplay } from './AccountViewTypes';

type Props = {
    useTabs?: boolean;
    className?: string;
    onChangeValue: (value: string) => void;
} & React.PropsWithChildren;

const AccountViewWrapper: React.FC<Props> = ({ useTabs = false, className, onChangeValue, children }) => {
    const translated = useTranslation();
    return (
        <div className={className}>
            <section
                className={classNames('sgw-account-details__meta account-view__balance-container', {
                    'use-tabs': useTabs,
                })}
            >
                {useTabs ? (
                    <Tabs id="account-view-bsu-tabs" onChangeValue={onChangeValue}>
                        <Tabs.TabList>
                            <Tabs.TabButton value={BsuDisplay.YEARLY}>
                                {translated.bsuDetails.displayYearly}
                            </Tabs.TabButton>
                            <Tabs.TabButton value={BsuDisplay.TOTAL}>
                                {translated.bsuDetails.displayTotal}
                            </Tabs.TabButton>
                        </Tabs.TabList>
                        {children}
                        <div className="background-wrapper">
                            <div className="background" />
                        </div>
                    </Tabs>
                ) : (
                    <>
                        {children}
                        <div className="background-wrapper">
                            <div className="background" />
                        </div>
                    </>
                )}
            </section>
        </div>
    );
};

export default AccountViewWrapper;
